module.exports = __webpack_public_path__ + "img/collection-weddingRingsMen.7336d35.webp";